export const HaloFotoApi = {
    getData: async function(menuItem) {
        const response = await fetch(`${process.env.REACT_APP_WEBSITE_API_URL}/${menuItem}`);
        const data =  response.json();
        return data;
    }
}

